export const START = "START";
export const SET_TIPO = "SET_TIPO";
export const SET_PRODOTTO = "SET_PRODOTTO";
export const SET_DOVE = "SET_DOVE";
export const SET_CF = "SET_CF";
export const SET_DATI_PERSONALI = "SET_DATI_PERSONALI";
export const SET_CONSENSI = "SET_CONSENSI";
export const SET_GIORNO = "SET_GIORNO";
export const SET_GIORNO_ONLY = "SET_GIORNO_ONLY";
export const SET_ORARIO = "SET_ORARIO";
export const SET_FILIALE = "SET_FILIALE";
export const CLEAR_FILIALI = "CLEAR_FILIALI";
export const CLEAR_CONSENSI = "CLEAR_CONSENSI";
export const SET_FILIALI = "SET_FILIALI";
export const SET_DISPONIBILITA = "SET_DISPONIBILITA";
export const SET_RECAP = "SET_RECAP";
export const CLEAR_DISPONIBILITA = "CLEAR_DISPONIBILITA";
export const SET_VECCHIO_APPUNTAMENTO = "SET_VECCHIO_APPUNTAMENTO";
export const SET_OPP_ID = "SET_OPP_ID";
export const SET_PRODUCT_FROM_PARAMS = "SET_PRODUCT_FROM_PARAMS";
export const SET_DOVE_NO_RESET = "SET_DOVE_NO_RESET";
export const SET_UTM = "SET_UTM";
export const SET_FLUSSO_MODIFICA = "SET_FLUSSO_MODIFICA";
export const SET_MODIFICANDO = "SET_MODIFICANDO";
export const SET_HISTORY_BACK = "SET_HISTORY_BACK";
export const CLEAR_HISTORY_BACK = "CLEAR_HISTORY_BACK";
export const START_BACK_EVENT = "START_BACK_EVENT";
export const END_BACK_EVENT = "END_BACK_EVENT";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const GET_DATA_FROM_TOKEN = "GET_DATA_FROM_TOKEN";
export const SET_LAST_BACK_TIMESTAMP = "SET_LAST_BACK_TIMESTAMP";
export const SET_SOURCE = "SET_SOURCE";
export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export const SET_CAP_EXCLUDED = "SET_CAP_EXCLUDED";
export const SET_FOUND_DB_COMPASS = "SET_FOUND_DB_COMPASS";
export const SET_TELEFONICO = "SET_TELEFONICO";
export const SET_FAFUNNEL_TRIGGERED = "SET_FAFUNNEL_TRIGGERED";
export const SET_OVERLAY = "SET_OVERLAY";
export const SET_FLOW_SWITCH = "SET_FLOW_SWITCH";
export const SET_RICONTATTO = "SET_RICONTATTO";
export const SET_RICONTATTO_CF = "SET_RICONTATTO_CF";
export const SET_RICONTATTO_RICHIESTO = "SET_RICONTATTO_RICHIESTO";
export const SET_FILIALE_RICONTATTO = "SET_FILIALE_RICONTATTO";
export const SET_ACCESS_ROUTE = "SET_ACCESS_ROUTE";


// WEBPACK FOOTER //
// ./src/constants/action-types.js